import { render } from "./DetailTahlil.vue?vue&type=template&id=9ebfd738&scoped=true"
import script from "./DetailTahlil.vue?vue&type=script&lang=js"
export * from "./DetailTahlil.vue?vue&type=script&lang=js"

import "./DetailTahlil.vue?vue&type=style&index=0&id=9ebfd738&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebfd738"]])

export default __exports__